// extracted by mini-css-extract-plugin
export default {"ant-switch-checked":"FormModal_ant-switch-checked__rC46i","ModalTitle":"FormModal_ModalTitle__q4Rmy"};